// extracted by css-extract-rspack-plugin
export default {"greetingLogoContainer":"ZrWSt","greetingLogo":"PnqTX","isCool":"D0JY0","isNotCool":"PS_Gl","greetingMessage":"i61EJ","withLogo":"V0XAQ","withoutLogo":"eWpdp"};